import { getSharedLinks } from './getSharedLinks';
import getExecutiveMenuItem from './getExecutiveMenuItem';
import messages from '../lib/messages.json';
import { getTargetOrigin } from '../lib/redirectRouteToDomain';
import hasLocalizedStatisticsPage from '../lib/hasLocalizedStatisticsPage';
import hasExecutivePage from '../lib/hasExecutivePage';

const getFooter = (
  newsboard,
  board,
  hasLocalNews,
  intl,
  locale,
  hasNews,
  origin,
) => {
  const newsboardType = hasLocalNews ? 'local_newsboard' : 'newsboard';

  const conditionsFooterItem = locale === 'de-DE' ? {
    id: 'AGB',
    href: 'https://fashionunited.de/conditions',
    route: 'conditions',
    router: true,
  } : {
    id: 'conditions',
    href: 'https://fashionunited.info/conditions',
    target: '_blank',
    rel: 'noreferrer noopener',
  };

  const sharedLinks = [
    {
      id: 'connect',
      list: [
        {
          id: 'newsletter',
          href: intl.formatMessage(messages['newsletter.href']),
        },
        ...(hasNews ? [{
          id: 'rss',
          href: `/rss/news?${newsboardType}=${board}`,
        }] : []),
        {
          id: 'youtube',
          href: 'https://www.youtube.com/fashionunited',
        },
        {
          id: 'facebook',
          href: intl.formatMessage(messages['facebook.href']),
        },
        {
          id: 'linkedin',
          href: 'https://www.linkedin.com/company/fashionunited',
        },
        {
          id: 'instagram',
          href: 'https://www.instagram.com/fashionunitedhq',
        },
      ],
    },
    {
      id: 'about',
      list: [
        {
          id: 'fashionUnited',
          href: 'https://fashionunited.info',
          router: newsboard === 'FASHIONUNITED_INFO',
          route: 'index',
        },
        {
          id: 'editorialStatute',
          href: intl.formatMessage(messages['editorialStatute.href']),
          router: true,
          route: 'editorial-statute',
        },
        {
          id: 'contact',
          href: '/contact',
          router: true,
          route: 'contact',
        },
        {
          id: 'privacy',
          href: '/privacy',
          router: true,
          route: 'privacy',
        },
        {
          id: 'ethics',
          href: '/code-of-ethics',
          router: true,
          route: 'code-of-ethics',
        },
        conditionsFooterItem,
      ],
    },
  ];

  return newsboard === 'FASHIONUNITED_INFO' ? [
    {
      id: 'news',
      list: [
        {
          id: 'fashionNews',
          href: 'https://fashionunited.info/fashionunited-news',
          router: true,
          route: 'fashionunited-news',
        },
      ],
    },
    {
      id: 'careerInFashion',
      list: [
        {
          id: 'careers',
          href: 'https://fashionunited.com/fashion-jobs/work-at/fashionunited-jobs?locales=all',
        },
      ],
    },
    ...sharedLinks,
  ] : [
    {
      id: 'news',
      list: [
        ...getExecutiveMenuItem(newsboard),
        ...getSharedLinks(intl, hasNews),
        ...(hasNews ? [{
          id: 'fashionStatistics',
          router: true,
          route: hasLocalizedStatisticsPage(locale)
            ? `country-statistics.${locale}` : 'statistics',
        }] : []),
        {
          id: 'educationNews',
          href: 'https://fashionunited.com/education',
          router: newsboard === 'FASHIONUNITED_COM',
          route: 'education',
        },
        ...(hasExecutivePage(newsboard) ? [] : [{
          id: 'executiveNews',
          href: 'https://fashionunited.com/executive',
          router: false,
        }]),
      ],
    },
    {
      id: 'careerInFashion',
      list: [
        {
          id: 'findAFashionJob',
          route: `jobs.${locale}`,
          router: true,
        },
        {
          id: 'findAnInternship',
          route: `jobs.${locale}`,
          params: {
            categoryParam: intl.formatMessage(
              messages['jobs.category.internships.param'],
            ),
          },
          router: true,
        },
        {
          id: 'postAFashionVacancy',
          router: true,
          route: `submit-job-postings.${locale}`,
        },
        {
          id: 'companies',
          router: true,
          route: `company-profiles.${locale}`,
        },
        {
          id: 'cities',
          router: true,
          route: `jobs-cities.${locale}`,
        },
        {
          id: 'positionsInFashion',
          router: true,
          route: `jobs-positions.${locale}`,
        },
        {
          id: 'dashboard',
          router: false,
          href: 'https://dashboard.fashionunited.com',
          target: '_blank',
        },
      ],
    },
    {
      id: 'events',
      list: [
        {
          id: 'tradeFairsCalendar',
          router: true,
          route: 'events',
        },
        {
          id: 'lookbook',
          href: `${getTargetOrigin(origin)}/lookbook`,
          router: newsboard === 'FASHIONUNITED_COM',
          route: 'lookbook',
        },
        {
          id: 'brandDirectory',
          href: 'https://fashionunited.com/brands',
          router: newsboard === 'FASHIONUNITED_COM',
          route: 'brands',
        },
        {
          id: 'marketplace',
          href: `${getTargetOrigin(origin)}/marketplace`,
          router: newsboard === 'FASHIONUNITED_COM',
          route: 'marketplace',
        },
      ],
    },
    ...sharedLinks,
  ];
};

export default getFooter;
